import { FEATURE_KEYS, MODULE_KEYS, OPERATION_IDS } from '../routes/ids.js';
const tk = (value) => value;
const fieldId = (value) => value;
const formId = (value) => value;
const commandId = (value) => value;
const licenseCollection = {
    minItems: 0,
    maxItems: 100,
    addLabelKey: tk('organization.regulatoryProfile.licenses.add'),
    removeLabelKey: tk('organization.regulatoryProfile.licenses.remove'),
    emptyStateKey: tk('organization.regulatoryProfile.licenses.empty'),
    itemLabelKey: tk('organization.regulatoryProfile.licenses.item'),
    summaryMode: 'count',
    columns: [
        {
            name: 'authority',
            labelKey: tk('organization.regulatoryProfile.fields.authority'),
            fieldType: 'select',
            required: true,
            options: ['IRD', 'SEBON', 'NRB', 'FIU_NEPAL'].map((value) => ({
                value,
                labelKey: tk(`organization.regulatoryProfile.authority.${value}`),
            })),
            layout: { xs: 12, sm: 6, md: 3 },
        },
        {
            name: 'licenseType',
            labelKey: tk('organization.regulatoryProfile.fields.licenseType'),
            fieldType: 'select',
            required: true,
            options: [
                'SEBON_PORTFOLIO_MANAGER',
                'SEBON_MERCHANT_BANKER',
                'SEBON_SECURITIES_BROKER',
                'NRB_CLASS_A_BANK',
                'NRB_CLASS_B_BANK',
                'NRB_CLASS_C_FINANCE',
                'NRB_CLASS_D_MICROFINANCE',
                'NRB_PAYMENT_SERVICE_PROVIDER',
                'NRB_OTHER_LICENSED_ENTITY',
                'FIU_REPORTING_ENTITY',
            ].map((value) => ({
                value,
                labelKey: tk(`organization.regulatoryProfile.licenseType.${value}`),
            })),
            layout: { xs: 12, sm: 6, md: 3 },
        },
        {
            name: 'licenseNumber',
            labelKey: tk('organization.regulatoryProfile.fields.licenseNumber'),
            fieldType: 'text',
            required: true,
            layout: { xs: 12, sm: 6, md: 3 },
        },
        {
            name: 'status',
            labelKey: tk('organization.regulatoryProfile.fields.status'),
            fieldType: 'select',
            required: true,
            defaultValue: 'ACTIVE',
            options: ['ACTIVE', 'SUSPENDED', 'REVOKED', 'EXPIRED'].map((value) => ({
                value,
                labelKey: tk(`organization.regulatoryProfile.status.${value}`),
            })),
            layout: { xs: 12, sm: 6, md: 3 },
        },
        {
            name: 'effectiveFrom',
            labelKey: tk('organization.regulatoryProfile.fields.effectiveFrom'),
            fieldType: 'date',
            required: true,
            layout: { xs: 12, sm: 6, md: 3 },
        },
        {
            name: 'effectiveTo',
            labelKey: tk('organization.regulatoryProfile.fields.effectiveTo'),
            fieldType: 'date',
            layout: { xs: 12, sm: 6, md: 3 },
        },
        {
            name: 'sourceReference',
            labelKey: tk('organization.regulatoryProfile.fields.sourceReference'),
            fieldType: 'text',
            required: true,
            layout: { xs: 12, sm: 12, md: 6 },
        },
    ],
};
const fields = [
    {
        id: fieldId('field.organization.regulatoryProfile.expectedVersion'),
        name: 'expectedVersion',
        labelKey: tk('organization.regulatoryProfile.fields.expectedVersion'),
        fieldType: 'hidden',
        value: { submitBehavior: 'include', hiddenValuePolicy: 'preserve' },
    },
    {
        id: fieldId('field.organization.regulatoryProfile.panNumber'),
        name: 'panNumber',
        labelKey: tk('organization.regulatoryProfile.fields.panNumber'),
        helpTextKey: tk('organization.regulatoryProfile.help.panNumber'),
        fieldType: 'text',
        validation: {
            rules: [
                { ruleId: 'required', messageKey: tk('validation.required') },
                {
                    ruleId: 'pattern',
                    params: { pattern: '^\\d{9}$' },
                    messageKey: tk('organization.regulatoryProfile.validation.panNumber'),
                },
            ],
            validateWhen: 'submit',
        },
        value: { submitBehavior: 'include', hiddenValuePolicy: 'preserve' },
        layout: { md: 6 },
    },
    {
        id: fieldId('field.organization.regulatoryProfile.sebonRegistrationNumber'),
        name: 'sebonRegistrationNumber',
        labelKey: tk('organization.regulatoryProfile.fields.sebonRegistrationNumber'),
        fieldType: 'text',
        value: { submitBehavior: 'include', hiddenValuePolicy: 'preserve' },
        layout: { md: 6 },
    },
    {
        id: fieldId('field.organization.regulatoryProfile.licenses'),
        name: 'licenses',
        labelKey: tk('organization.regulatoryProfile.fields.licenses'),
        helpTextKey: tk('organization.regulatoryProfile.help.licenses'),
        fieldType: 'collection',
        collection: licenseCollection,
        value: {
            defaultValue: [],
            submitBehavior: 'include',
            hiddenValuePolicy: 'preserve',
        },
        layout: { md: 12 },
    },
];
const saveAction = {
    id: 'action.organization.regulatoryProfile.save',
    schemaVersion: 1,
    module: MODULE_KEYS.ADMIN,
    feature: FEATURE_KEYS.ADMIN_REGULATORY_PROFILE,
    telemetryId: 'experience.action.organization.regulatoryProfile.save',
    accessibilityLabelKey: tk('organization.regulatoryProfile.actions.save'),
    privacyClassification: 'CONFIDENTIAL',
    availability: 'AVAILABLE',
    owner: 'organization-administration',
    operationId: OPERATION_IDS.ORGANIZATION_REGULATORY_PROFILE_UPDATE,
    labelKey: tk('organization.regulatoryProfile.actions.save'),
    kind: 'command',
    commandId: commandId('cmd.admin.organization-regulatory-profile.update'),
    submitBehavior: 'form_submit',
    submitConfig: {
        validatesForm: true,
        requiresDirty: true,
        requiresValid: true,
        resetBehavior: 'toServerValues',
    },
    intent: 'primary',
    idempotencyRequired: true,
    successBehavior: 'NO_OP',
    successMessageKey: tk('organization.regulatoryProfile.messages.saved'),
    errorBehavior: 'SHOW_INLINE_ERROR',
    errorMessageKey: tk('common.error.unexpected'),
    order: 10,
    group: 'primary',
};
export const ORGANIZATION_REGULATORY_PROFILE_FORM = {
    id: formId('form.admin.organizationRegulatoryProfile'),
    schemaVersion: 1,
    module: MODULE_KEYS.ADMIN,
    feature: FEATURE_KEYS.ADMIN_REGULATORY_PROFILE,
    telemetryId: 'experience.form.organization.regulatoryProfile',
    accessibilityLabelKey: tk('organization.regulatoryProfile.title'),
    privacyClassification: 'CONFIDENTIAL',
    availability: 'AVAILABLE',
    owner: 'organization-administration',
    operationId: OPERATION_IDS.ORGANIZATION_REGULATORY_PROFILE_UPDATE,
    titleKey: tk('organization.regulatoryProfile.title'),
    descriptionKey: tk('organization.regulatoryProfile.description'),
    mode: 'edit',
    fields,
    sections: [
        {
            id: 'section.organization.regulatoryProfile.identity',
            titleKey: tk('organization.regulatoryProfile.sections.identity'),
            fields: [
                fieldId('field.organization.regulatoryProfile.panNumber'),
                fieldId('field.organization.regulatoryProfile.sebonRegistrationNumber'),
            ],
            layout: { columns: 2 },
        },
        {
            id: 'section.organization.regulatoryProfile.licenses',
            titleKey: tk('organization.regulatoryProfile.sections.licenses'),
            descriptionKey: tk('organization.regulatoryProfile.help.licenses'),
            fields: [fieldId('field.organization.regulatoryProfile.licenses')],
        },
    ],
    actions: [saveAction],
    validation: { validateWhen: 'submit' },
    submission: {
        defaultCommandId: commandId('cmd.admin.organization-regulatory-profile.update'),
        includeFields: fields.map((field) => field.id),
        successMessageKey: tk('organization.regulatoryProfile.messages.saved'),
        errorMessageKey: tk('common.error.unexpected'),
    },
};
